import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TASKTYPE_LOAD,
    ACTION_TASKTYPE_LOAD_BY_ID,

    ACTION_TASKTYPE_SAVE,

    ACTION_TASKTYPE_CREATE,

    ACTION_TASKTYPE_VALIDATE,

    ITaskTypeLoadAction,
    ITaskTypeLoadByIdAction,
    ITaskTypeLoadFailureAction,
    ITaskTypeLoadSuccessAction,

    ITaskTypeSaveAction,
    ITaskTypeSaveSuccessAction,
    ITaskTypeSaveFailureAction,

    ITaskTypeCreateAction,
    ITaskTypeCreateSuccessAction,
    ITaskTypeCreateFailureAction,

    ITaskTypeValidateAction,
    ITaskTypeValidateSuccessAction,
    ITaskTypeValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/taskTypes";
import { taskTypeApi } from "../services/taskType";

export const
    getTaskTypesEpic = (action$): Observable<ITaskTypeLoadSuccessAction | ITaskTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_TASKTYPE_LOAD)
            .mergeMap((_action: ITaskTypeLoadAction) => {
                return taskTypeApi
                    .getTaskTypes()
                    .map(response =>
                        LoadSuccess(response.taskTypes, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTaskTypeByIdEpic = (action$): Observable<ITaskTypeLoadSuccessAction | ITaskTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_TASKTYPE_LOAD_BY_ID)
            .mergeMap((action: ITaskTypeLoadByIdAction) => {
                return taskTypeApi
                    .getTaskTypeById(action.id)
                    .map(response =>
                        LoadSuccess(response.taskType, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTaskTypeEpic = (action$): Observable<ITaskTypeSaveSuccessAction | ITaskTypeSaveFailureAction> => {
        return action$
            .ofType(ACTION_TASKTYPE_SAVE)
            .mergeMap((action: ITaskTypeSaveAction) => {
                return taskTypeApi
                    .setTaskType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.taskType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTaskTypeEpic = (action$): Observable<ITaskTypeCreateSuccessAction | ITaskTypeCreateFailureAction> => {
        return action$
            .ofType(ACTION_TASKTYPE_CREATE)
            .mergeMap((_action: ITaskTypeCreateAction) => {
                return taskTypeApi
                    .createTaskType()
                    .map(response =>
                        CreateSuccess(
                            response.taskType,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTaskTypeEpic = (action$): Observable<ITaskTypeValidateSuccessAction | ITaskTypeValidateFailureAction> => {
        return action$
            .ofType(ACTION_TASKTYPE_VALIDATE)
            .mergeMap((action: ITaskTypeValidateAction) => {
                return taskTypeApi
                    .validateTaskType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.taskType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }